<template>
  <div id="batchManagement">
    <div class="container" id="batchManagement-container">
      <ul class="nav nav-tabs" id="batchManagement-ulNavTabs">
        <li class="nav-item" id="batchManagement-caseBatch-navItem">
          <a class="nav-link" href="#"  @click.prevent="activeTab = 'POLICYCASE_BATCH_MANAGEMENT'"
             :class="{ 'active': activeTab === 'POLICYCASE_BATCH_MANAGEMENT' }" id="batchManagement-caseBatch-navItemLink">
            {{ 'POLICYCASE_BATCH_MANAGEMENT' | translate }}
          </a>
        </li>
        <li class="nav-item" id="batchManagement-customerBatch-navItem">
          <a class="nav-link" href="#" @click.prevent="activeTab = 'CUSTOMER_BATCH_MANAGEMENT'"
             :class="{ 'active': activeTab === 'CUSTOMER_BATCH_MANAGEMENT' }" id="batchManagement-customerBatch-navItemLink">
            {{ 'CUSTOMER_BATCH_MANAGEMENT' | translate }}
          </a>
        </li>
      </ul>
    </div>

    <div class="container mt-4" id="batchManagement-caseBatch-container">
      <div class="row mb-1" id="batchManagement-caseBatch-row">
        <div class="col-lg-7" id="batchManagement-caseBatch-headerCol">
          <!-- TITLE -->
          <h5>{{ activeTab | translate }}</h5>
        </div>
        <div class="col-lg-5" id="batchManagement-caseBatch-actionItemsCol">
          <!-- SEARCH -->
          <div class="input-group" id="batchManagement-caseBatch-inputGroupDiv">
            <input :placeholder="'SEARCH_BATCHES' | translate" class="form-control border-right-0" type="search" v-model="batchFilter" id="batchManagement-caseBatch-inputGroup">
            <span class="input-group-append" id="batchManagement-caseBatch-inputGroup-span">
              <div class="input-group-text bg-transparent" id="batchManagement-caseBatch-inputGroup-icon"><i class="fa fa-search" aria-hidden="true" id="batchManagement-caseBatch-inputGroup-data"></i></div>
            </span>
          </div>
        </div>
      </div>
    </div>

    <batch-management-header ref="batchManagementHeader"
                             v-if="activeTabComponent"
                             :actions="activeTabComponent.actionsAndAllowedRoles"
                             :batchSelectionEmpty="!activeTabComponent || !activeTabComponent.selected.length"
                             @execute-action="executeAction"
                             @toggle-select-all="toggleSelectAll"
                             @toggle-file-selected="toggleFileSelected"
                             id="batchManagement-caseBatch-batchManagementHeader"
    ></batch-management-header>

    <div class="tab-content" id="batchManagement-caseBatch-tabContentDiv">
      <policycase-batch-management
              ref="POLICYCASE_BATCH_MANAGEMENT"
              v-if="activeTab === 'POLICYCASE_BATCH_MANAGEMENT'"
              :jobs="jobs"
              :batchFilter="batchFilter"
              @set-active-component="setActiveTabComponent"
              @update-allselected="updateHeaderCheckbox"
              id="batchManagement-POLICYCASE_BATCH_MANAGEMENT"
      ></policycase-batch-management>
      <customer-batch-management
              ref="CUSTOMER_BATCH_MANAGEMENT"
              v-if="activeTab === 'CUSTOMER_BATCH_MANAGEMENT'"
              :jobs="jobs"
              :batchFilter="batchFilter"
              @set-active-component="setActiveTabComponent"
              @update-allselected="updateHeaderCheckbox"
              id="batchManagement-CUSTOMER_BATCH_MANAGEMENT">
      </customer-batch-management>
    </div>

    <alert-dialog :show="showAlertForRejectedStatusesRecalc"
                  :textLabel="'msg.FOLLOWING_STATUSES_CANNOT_RECALCULATE'"
                  @hide-dialog="showAlertForRejectedStatusesRecalc = false"
                  id="batchManagement-alertDialog-FOLLOWING_STATUSES_CANNOT_RECALCULATE">
    </alert-dialog>
    <alert-dialog :show="showAlertForRejectedStatusesClose"
                  :textLabel="'msg.FOLLOWING_STATUSES_CANNOT_CLOSE'"
                  @hide-dialog="showAlertForRejectedStatusesClose = false"
                  id="batchManagement-alertDialog-FOLLOWING_STATUSES_CANNOT_CLOSE">
    </alert-dialog>
    <confirm-dialog :show="showConfirmForDeleteAction"
                    :textLabel="'msg.SURE_DELETE_BATCHES'"
                    @hide-dialog="showConfirmForDeleteAction = false"
                    id="batchManagement-alertDialog-SURE_DELETE_BATCHES"
                    @confirm="executeActionDelete">
    </confirm-dialog>
  </div>
</template>

<script>
import RestService from '../../service/RestService.js';
import BatchManagementHeader from './BatchManagementHeader';
import CustomerBatchManagement from './CustomerBatchManagement';
import PolicycaseBatchManagement from './PolicycaseBatchManagement';
import AlertDialog from '../dialog/AlertDialog';
import ConfirmDialog from '../dialog/ConfirmDialog';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  components: { BatchManagementHeader, CustomerBatchManagement, PolicycaseBatchManagement, AlertDialog, ConfirmDialog },
  data() {
    return {
      rest: this.initRestService(),
      activeTab: 'POLICYCASE_BATCH_MANAGEMENT',
      activeTabComponent: null,
      batchFilter: '',
      jobs: [],
      interval: null,
      showAlertForRejectedStatusesRecalc: false,
      showAlertForRejectedStatusesClose: false,
      showConfirmForDeleteAction: false
    }
  },
  beforeMount() {
    this.init();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    init() {
      this.getRunningAndPendingJobs();
    },
    setActiveTabComponent(refString) {
      this.activeTabComponent = this.$refs[refString];
    },
    async getRunningAndPendingJobs() {
      const res = await this.rest.getRunningAndPendingJobs();
      this.jobs = res.data;
    },
    executeAction(selectedAction) {
      switch (selectedAction) {
        case 'recalc':
          this.executeActionRecalc();
          break;
        case 'close':
          this.executeActionClose();
          break;
        case 'delete':
        case 'delete_customers':
          this.showConfirmForDeleteAction = true;
          break;
        default:
          this.$log.error('Unrecognised batch action');
      }
    },
    executeActionRecalc() {
      let selectedBatches = this.activeTabComponent.getSelectedBatchesForRecalc();
      if (selectedBatches.length > 0) {
        this.sendAction(selectedBatches);
      } else {
        this.showAlertForRejectedStatusesRecalc = true;
      }
    },
    executeActionClose() {
      let selectedBatches = this.activeTabComponent.getSelectedBatchesForClose();
      if (selectedBatches.length > 0) {
        this.sendAction(selectedBatches);
      } else {
        this.showAlertForRejectedStatusesClose = true;
      }
    },
    executeActionDelete() {
      let selectedBatches = this.activeTabComponent.getSelectedBatchesForDelete();
      this.showConfirmForDeleteAction = false;
      this.sendAction(selectedBatches);
    },
    sendAction(batches) {
      const selectedAction = this.$refs.batchManagementHeader.selectedAction;
      const selectedActionUppercase = selectedAction.toUpperCase();
      this.rest.sendBatchAction(selectedAction, batches).then(() => {
        this.$notify({
          type: 'alert-success',
          text: this.$options.filters.translate(selectedActionUppercase + '_ACTION_ADDED_QUEUE', 'msg')
        });
        this.activeTabComponent.deselectAllBatches();
        this.getRunningAndPendingJobs();
        if (!this.interval) {
          this.interval = setInterval(() => {
            this.poll();
          }, 2000);
        }
        GeneralConfigService.forceUpdatePolicyCaseBatchIds = true;
      }).catch((err) => {
        this.$notify({
          type: 'alert-danger',
          duration: -1,
          text: this.$options.filters.translate(selectedActionUppercase + '_ACTION_NOT_ADDED_QUEUE', 'msg')
        });
        if (typeof err.response !== 'undefined') {
          this.$log.error(err.response.data);
        } else {
          this.$log.error(err);
        }
      });
    },
    async poll() {
      if (this.activeTabComponent.runningBatchesExist) {
        await this.getRunningAndPendingJobs();
        this.activeTabComponent.poll();
      } else {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    toggleSelectAll(bool) {
      bool ? this.activeTabComponent.selectAllBatches() : this.activeTabComponent.deselectAllBatches();
    },
    toggleFileSelected(bool) {
      bool ? this.activeTabComponent.disableBatchSelection() : this.activeTabComponent.enableBatchSelection();
    },
    updateHeaderCheckbox(allSelected, indeterminate) {
      this.$refs.batchManagementHeader.updateCheckbox(allSelected, indeterminate);
    }
  },
  watch: {
    activeTabComponent() {
      if (this.$refs.batchManagementHeader) this.$refs.batchManagementHeader.updateCheckbox(false, false);
    }
  }
}
</script>

<style scoped>
  >>> table > tr:nth-child(2) > th {
    border-top: 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/batch/BatchManagement.vue